import Toolbar from "toolbar/Toolbar";
import ToolbarItemLink from "toolbar/ToolbarItemLink";
import GlobalEvents from "base/GlobalEvents";

if ("string" === typeof window.ADMIN_MODULE) {
    $(() => {
        let event = {text: "Back to website", icon: "back", url: window.CONFIG.urls.website};
        if (GlobalEvents.emit('toolbar.showBackToWebsite', event)) {
            Toolbar.addDefaultItem(new ToolbarItemLink(event.text, event.url, event.icon), 10, Toolbar.LEFT);
        }
    });
}
